var map = {
	"./ajax-form/index": "./js/src/components/ajax-form/index.js",
	"./ask-login/index": "./js/src/components/ask-login/index.js",
	"./attachments-middleware/index": "./js/src/components/attachments-middleware/index.js",
	"./attachments/index": "./js/src/components/attachments/index.js",
	"./avatar-list/index": "./js/src/components/avatar-list/index.js",
	"./avatar-uploader/index": "./js/src/components/avatar-uploader/index.js",
	"./avatar/index": "./js/src/components/avatar/index.js",
	"./box-widget/index": "./js/src/components/box-widget/index.tsx",
	"./close-element/index": "./js/src/components/close-element/index.js",
	"./cropper/index": "./js/src/components/cropper/index.js",
	"./current-user/index": "./js/src/components/current-user/index.js",
	"./data-loader/index": "./js/src/components/data-loader/index.js",
	"./editor-wysiwyg/index": "./js/src/components/editor-wysiwyg/index.js",
	"./google-analytics/index": "./js/src/components/google-analytics/index.js",
	"./google-tag-manager/index": "./js/src/components/google-tag-manager/index.js",
	"./insided-api/index": "./js/src/components/insided-api/index.js",
	"./login/index": "./js/src/components/login/index.js",
	"./loginModalOnLoad/index": "./js/src/components/loginModalOnLoad/index.js",
	"./modal/index": "./js/src/components/modal/index.js",
	"./notifications/index": "./js/src/components/notifications/index.js",
	"./popover/index": "./js/src/components/popover/index.js",
	"./post-likes/index": "./js/src/components/post-likes/index.js",
	"./reactModal/index": "./js/src/components/reactModal/index.tsx",
	"./scrollTop/index": "./js/src/components/scrollTop/index.js",
	"./scrollTopStickyButton/index": "./js/src/components/scrollTopStickyButton/index.js",
	"./search-conversion/index": "./js/src/components/search-conversion/index.ts",
	"./simple-user/index": "./js/src/components/simple-user/index.js",
	"./subscribe/index": "./js/src/components/subscribe/index.js",
	"./survey/index": "./js/src/components/survey/index.js",
	"./switch/index": "./js/src/components/switch/index.js",
	"./topic-list/index": "./js/src/components/topic-list/index.js",
	"./tracker/index": "./js/src/components/tracker/index.js",
	"./translation-form/index": "./js/src/components/translation-form/index.js",
	"./translation-switch/index": "./js/src/components/translation-switch/index.js",
	"./uploader/index": "./js/src/components/uploader/index.js",
	"./widget/index": "./js/src/components/widget/index.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js/src/components sync recursive ^\\.\\/.*\\/index$";